<script setup lang="ts">

import OnboardingSteps from '@/components/OnboardingSteps.vue'
import type { OnboardingStep } from '@/types/onboarding'
import Onboarding2 from '@/assets/images/onboarding/onboarding-2.png'
import Onboarding3 from '@/assets/images/onboarding/onboarding-3.png'
import Onboarding4 from '@/assets/images/onboarding/onboarding-4.png'
import Onboarding5 from '@/assets/images/onboarding/onboarding-5.png'
import { ref } from 'vue'
import { useTranslate } from '@tolgee/vue'
import router from '@/router'

const { t } = useTranslate()

const steps: OnboardingStep[] = [
  {
    index: 0,
    title: t.value('onboarding.welcome.title', 'Welcome to Dropee'),
    description: t.value('onboarding.welcome.description', 'Play to become a successful token creator, and win airdrops and rewards from top partners!'),
  },
  {
    index: 1,
    title: t.value('onboarding.tap.title', 'Tap and earn coins'),
    description: t.value('onboarding.tap.description', 'Tap to earn in-game coins. \nUse boosters to grow even faster.'),
    image: Onboarding2,
  },
  {
    index: 2,
    title: t.value('onboarding.improve.title', 'Boost passive profits'),
    description: t.value('onboarding.improve.description', 'Level up your cards and increase your \npassive profits even when you are away!'),
    image: Onboarding3,
  },
  {
    index: 3,
    title: t.value('onboarding.invite.title', 'Invite friends, \nget bonuses together'),
    description: t.value('onboarding.invite.description', 'You and your friend will both earn coins.'),
    image: Onboarding4,
  },
  {
    index: 4,
    title: t.value('onboarding.rewards.title', 'Earn daily rewards'),
    description: t.value('onboarding.rewards.description', 'Spin the wheel to win rewards, in-game coins or USDT every day!'),
    image: Onboarding5,
    buttonLabel: t.value('onboarding.close', 'Close'),
  },
]

const currentStep = ref<OnboardingStep>(steps[0])

function goNext() {
  if (currentStep.value.index !== steps.length - 1) {
    currentStep.value = steps[currentStep.value.index + 1]
  } else {
    router.back()
  }
}
</script>

<template>
  <div
    class="flex-1 flex flex-col"
    :class="{'onboarding-outer-background': currentStep.index === 0}"
  >
    <div
      class="flex-1 flex flex-col py-8"
      :class="{'onboarding-inner-background': currentStep.index === 0}"
    >
      <OnboardingSteps
        :current-step="currentStep"
        :steps="steps"
        @set-step="currentStep = steps[$event]"
        @go-next="goNext"
      />
    </div>
  </div>
</template>

<style scoped>

</style>